const setToken = idToken => {
        localStorage.setItem('humanlogstoken', idToken);
};

const getToken = () => {
        return localStorage.getItem("humanlogstoken");
};

export { setToken, getToken };